import type { QueryClient } from '@tanstack/react-query';
import { notFound } from '@tanstack/react-router';
import { featuresQuery } from '@/features/feature-flags/use-feature';

/** Route guard (beforeLoad): project templates ship behind the `project_templates` flag. */
export async function requireTemplatesFeature(queryClient: QueryClient): Promise<void> {
  const { flags } = await queryClient.query(featuresQuery);
  if (!flags.project_templates || !flags.projects) throw notFound();
}
